import {
  AgrLoginTypes,
  AgrEnvironment,
  IETFLocales,
  SignupSigninPolicy,
} from '@next/core-lib/environment';

export interface Environment extends AgrEnvironment {
  // add app specific environment variables here
}

export const environment: Environment = {
  APPLICATION_NAME: 'PoultryNEXT',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'PoultryNEXT',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [
    IETFLocales.nl,
    IETFLocales.pl,
    IETFLocales.en,
    IETFLocales.hu,
    IETFLocales.de,
    IETFLocales['ar-JO'],
    IETFLocales['nl-BE'],
    IETFLocales['fr-BE'],
  ],
  PRODUCTION: true,
  CUSTOMER_IN_LOCATION_SELECTOR: true,
  APIM_BASE_URL: 'http://localhost:4200/external',
};
